import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import {
    Typography,
    Card,
} from '@mui/material';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import TableHead from '@mui/material/TableHead';

export const ContentContainer = styled('div')(({ theme }) => ({
    position: 'relative',
    minHeight: 'calc(100vh - 64px)',
    paddingBottom: '100px',
    overflowY: 'auto',
    marginLeft: 70,
    [theme.breakpoints.down('md')]: {
        marginLeft: '50px', // Reduce margin on medium and smaller screens
    },
    [theme.breakpoints.down('sm')]: {
        minHeight: 'calc(100vh - 56px)', // Adjust minimum height for small screens if needed
        paddingBottom: '30px', // Further reduce padding for smaller screens
    },
}));


export const MainContent = styled('div')({
    padding: '20px',
    marginBottom: '20px',
    marginTop: '50px',
});

export const CenteredCard = styled(Card)({
    maxWidth: '100%',
    margin: '20px',
    marginTop: '80px',
    borderBottom: '2px solid dodgerblue',
    //borderRight: '2px solid dodgerblue',
    marginBottom: '10px',
});

export const StyledTableContainer = styled(Paper)(({ theme }) => ({
    padding: '16px',
    width: '90%', // Use a percentage width for responsiveness
    maxWidth: '600px', // Set a maximum width for larger screens
    minWidth: '300px', // Set a minimum width to prevent it from being too small
    margin: 'auto',
    overflowX: 'auto',
    boxShadow: 'none',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    border: 'none',
    [theme.breakpoints.down('sm')]: {
        padding: '12px', // Adjust padding for small screens
        width: '95%', // Slightly increase width on small screens
    },
    [theme.breakpoints.down('md')]: {
        padding: '14px', // Adjust padding for medium screens
    },
}));

export const HeaderTitle = styled(Typography)({
    flexGrow: 1,
    fontSize: '1.4rem',
    color: '#333',
    fontWeight: 'normal',
    textAlign: 'left',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
    marginLeft: '10px',
});

// Styled Table Head
export const StyledTableHead = styled(TableHead)({
    backgroundColor: '#333',
    color: '#ffffff',
    fontWeight: 'bold',
    borderRadius: '8px 8px 0 0',
    textAlign: 'center',
    '& th': {
        borderBottom: 'none',
    },
});

// Styled Table Column
export const StyledTableColumn = styled(TableCell)({
    fontWeight: 'bold',
    fontSize: '1rem',
    textAlign: 'center',
    padding: '12px 16px',
    backgroundColor: '#f0f0f0',
    borderRight: '1px solid #cccccc',
    color: '#333',
    borderRadius: '0',
    '&:last-child': {
        borderRight: 'none',
    },
    '&:hover': {
        backgroundColor: '#d6d6d6',
        transition: 'background-color 0.2s ease',
    },
});

// Styled Table Cell
export const StyledTableCell = styled(TableCell)({
    fontSize: '0.965rem',
    textAlign: 'center',
    padding: '12px 16px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #cccccc',
    color: '#333',
    borderRadius: '0',
    '&:hover': {
        backgroundColor: '#f5f5f5',
        transition: 'background-color 0.2s ease',
    },
});

export const StyledChartCard = styled(Card)(({ theme }) => ({
    maxWidth: '95%',
    margin: 'auto',
    marginBottom: theme.spacing(4),
    borderRadius: '25px 5px 25px 5px', // Unique asymmetrical rounded shape
    background: 'rgba(250, 250, 250, 0.85)', // Soft frosted white
    backdropFilter: 'blur(12px)', // Glass effect
    boxShadow: '0px 15px 35px rgba(0, 0, 0, 0.2)', // Elegant layered shadows
    border: '2px solid rgba(200, 200, 200, 0.5)', // Defined soft border
    padding: theme.spacing(3),
    overflow: 'hidden',
    position: 'relative',
    transition: '0.3s ease-in-out',

    '&::before': {
        content: '""',
        position: 'absolute',
        top: '-10%',
        left: '-10%',
        width: '120%',
        height: '120%',
        background: 'radial-gradient(circle at top left, rgba(255, 255, 255, 0.3), transparent)',
        opacity: 0.7,
        pointerEvents: 'none',
    },
}));

export const RefreshIcon = styled('img')({
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'rotate(360deg)',
    },
});

export const CustomTextField = styled(TextField)({
    '& .MuiInput-root': {
        color: 'dodgerblue',
        fontSize: '1rem',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'dodgerblue',
    },
    '& .MuiInput-underline:before': {
        borderBottomColor: 'dodgerblue',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: 'dodgerblue',
    },
});